import { Badge } from "../../../components/Badge";
import { Link } from "react-router-dom";
import Button from "../../../components/Button";
import React from "react";

interface ProjectGridInfo {
  id: number;
  project_id?: number;
  name: string;
  project_type?: string;
  methodology?: string;
  status?: string;
  estimated_annual_emission_reduction?: number;
  start_date?: string;
  end_date?: string;
  registry?: string;
  url?: string;
  description?: string;
}

interface ProjectGridProps {
  projects: ProjectGridInfo[];
}

const renderProjectGrid = (projects: ProjectGridInfo[]) =>
  projects.map((project) => (
    <div
      data-testid={`${project.id}`}
      key={`${project.id}`}
      className="flex w-full flex-col justify-center gap-2 rounded-lg border border-gray-300 bg-white p-4 shadow-md"
    >
      <h4 className={"text-md h-16 font-bold"}>
        {project.name}
        <span className="text-zinc-800 font-light">&nbsp;| ID: #{project.project_id}</span>
      </h4>

      <p className={"truncate border-gray-800 pb-4"} style={{ borderBottomWidth: "1px" }}>
        {project.description}
      </p>

      <div className="mt-2 flex items-center justify-between">
        <Badge>{project.status}</Badge>
        <Link to={`/project/${project.id}`}>
          <Button variant="outlined" className="hover:bg-gray-300">
            More details
          </Button>
        </Link>
      </div>
    </div>
  ));

export const ProjectGrid = ({ projects }: ProjectGridProps) => (
  <>{projects.length > 0 ? renderProjectGrid(projects) : null}</>
);
